import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { TYPE_LIST,LEAD_GATE } from "./type";

export const gateTypeList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.gates.gateTypeList}`
  );
  if (res) {
    const { data } = res;
    const payload = data.response?.data ?? data.data;
    dispatch({ type: TYPE_LIST, payload: payload });
    return true;
  }
};

export const fetchLeadGate = (leadId) => async (dispatch) => {
  // console.log(leadId);
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.gates.fetchLeadGate}?lead_id=${leadId}`
  );
  if (res) {
    const { data } = res;
    const payload = data.response?.data ?? data.data;
    dispatch({ type: LEAD_GATE, payload: payload });
    return true;
  }else{
    return 0;
  }
};

export const addApartmentGate = (gateData) => async () => {
  const res = await callWebService(
    callTypes.post,
    gateData,
    Config.gates.addApartmentGate
  );
  if (res) {
    const { data } = res.data.response;
    return data;
  } else {
    return null;
  }
};

export const addCorporateGate = (gateData) => async () => {
  const res = await callWebService(
    callTypes.post,
    gateData,
    Config.gates.addCorporateGate
  );
  if (res) {
    const { data } = res.data.response;
    return data;
  } else {
    return null;
  }
};
